import { makeBuilder } from "@smithy/core/client";
import { getEndpointPlugin } from "@smithy/core/endpoints";
import { commonParams } from "./endpoint/EndpointParameters";
export const command = makeBuilder(commonParams, "SimpleEmailService_v2", "SESv2Client", getEndpointPlugin);
export const _ep0 = {};
export const _ep1 = {
    EndpointId: { type: "contextParams", name: "EndpointId" },
};
export const _mw0 = (Command, cs, config, o) => [];
